import mergeByKey from 'array-merge-by-key';

import { NgModule } from '@angular/core';

import { UtilityService } from './services/utility.service';

@NgModule({
    providers: [
        UtilityService,
        {
            provide: 'MergeArrayByKey',
            useValue: mergeByKey,
        },
    ],
})

export class UtilityModule {}
